<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <PostForm @submit-requested="submitRequested"></PostForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import PostForm from './PostForm.vue'

  export default {
  components: { PostForm },
  methods: {
    ...mapActions('posts', ['postPost']),
    submitRequested (input) {
      this.postPost(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 